module.exports = __webpack_public_path__ + "static/img/excel.54f3554b.png";